import React from "react";
import { useDispatch } from "react-redux";
import { CssBaseline, Typography, WithStyles, withStyles } from "@material-ui/core";
import * as UserDetailsAction from "../../stores/user/UserDetailsAction";
import { CenteredContainer } from "../components/CenteredContainer/CenteredContainer";
import ToastStatusEnum from "../../constants/ToastStatusEnum";
import { useSnackbar } from "notistack";
import { useHistory, useLocation } from "react-router-dom";
import { PageBanner } from "../components/PageBanner/PageBanner";
import { AcceptTermsConditionsComponent, IAgrees } from "./AcceptTermsConditionsComponent";
import { BlueButton } from "../components/Buttons/BlueButton";
import { styles } from "./AcceptPrivacyNoticeView.styles";

export interface IAcceptPrivacyNoticeViewProps extends WithStyles<typeof styles> {}

const AcceptPrivacyNoticeViewPure: React.FunctionComponent<IAcceptPrivacyNoticeViewProps> = ({
    classes
}: IAcceptPrivacyNoticeViewProps) => {
    const history = useHistory();
    const location = useLocation();
    const { enqueueSnackbar } = useSnackbar();
    const userId = location?.state?.userId;
    const dispatch = useDispatch();

    const [agrees, setAgrees] = React.useState<IAgrees>({
        agreePrivacyNotice: false
    });

    const handleAgree = event => {
        setAgrees({
            ...agrees,
            [event.target.name]: !agrees[event.target.name]
        });
    };

    const acceptTermsAndConditions = () => {
        dispatch(UserDetailsAction.acceptPrivacyNotice(userId)).then(() => {
            enqueueSnackbar("Privacy notice accepted", { variant: ToastStatusEnum.Info });
            history.push("/accept-privacy-notice/success");
        });
    };

    return (
        <>
            <PageBanner title="Accept Privacy notice" isPublic />
            <CenteredContainer>
                <CssBaseline />
                <div>
                    <Typography variant="h2" className={classes.orderTitle}>
                        Accept the Privacy Notice first
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        In order to fully access the Datashop please read and accept the Privacy Notice.
                    </Typography>

                    <AcceptTermsConditionsComponent agrees={agrees} handleAgree={handleAgree} />
                    <BlueButton onClick={acceptTermsAndConditions} disabled={agrees.agreePrivacyNotice === false}>
                        Accept
                    </BlueButton>
                </div>
            </CenteredContainer>
        </>
    );
};

export const AcceptPrivacyNoticeView = withStyles(styles)(AcceptPrivacyNoticeViewPure);
